import React from 'react';
import image from './autoware_drive_only_title_white.png';
import { IconButton, styled } from '@mui/material';

const Image = styled('img')({
    height: '22px',
});

const Frame = styled(IconButton)({
    borderRadius: 0,
});

export type HomeButtonProps = {
    className?: string;
    onClick: () => void;
}

export const HomeButton = (props: HomeButtonProps) => {
    return (
        <Frame {...props}>
            <Image src={image} />
        </Frame>
    );
};
